<script lang="ts">
import { defineComponent } from 'vue'
export default defineComponent({
  name: 'dialogMaterial',
})
</script>
<template>
  <ant-Modal v-model:open="state.dialog.visible" transition-name="" :centered="true"
    :wrap-class-name="'wrap-template-dialog'" :title="state.dialog.title" :width="state.dialog.width"
    :confirm-loading="state.loading.submit" :ok-text="state.dialog.submitTxt"
    :cancel-button-props="state.viewType === 'detail' ? { style: { display: 'none' } } : {}" @ok="onSubmit"
    @cancel="closeDialog" :closable="!hasCancelOrCloseButton" :maskClosable="!hasCancelOrCloseButton">
    <a-spin :spinning="state.loading.dialogUpload">
      <!-- <div class="space-divider" />
      <div class="space-gap" style="height: 39px" /> -->
      <div class="form-content">
        <a-form ref="formRef" :model="state.ruleForm" :rules="state.rules" :wrapper-col="{ style: 'flex: 1' }">
          <a-row :gutter="16">
            <a-col :span="12">
              <a-form-item label="店铺类型" name="storeTypeCode">
                <a-select v-model:value="state.ruleForm.storeTypeCode" placeholder="请选择店铺类型"
                  :disabled="state.viewType === 'detail'" allow-clear>
                  <a-select-option v-for="item in storeTypeList" :key="item.code" :value="item.code">{{ item.name
                  }}</a-select-option>
                </a-select>
              </a-form-item>
            </a-col>
            <a-col :span="12">
              <a-form-item label="分类" name="categoryCode">
                <a-select v-model:value="state.ruleForm.categoryCode" placeholder="请选择分类"
                  :disabled="state.viewType === 'detail'" allow-clear>
                  <a-select-option v-for="item in categoryList" :key="item.code" :value="item.code">{{ item.name
                  }}</a-select-option>
                </a-select>
              </a-form-item>
            </a-col>
          </a-row>
          <a-form-item label="模板名称" name="materialName">
            <a-input v-model:value="state.ruleForm.materialName" placeholder="请输入模板名称" :maxlength="50"
              :show-count="state.viewType !== 'detail'" :disabled="state.viewType === 'detail'" allow-clear />
          </a-form-item>
          <a-form-item v-if="showSortField" label="小程序排序" name="sortOrder">
            <div class="sort-input-number">
              <button class="sort-btn" :disabled="isDetailView" @click="onSortChange(-1)">−</button>
              <input class="sort-input" type="number" :value="state.ruleForm.sortOrder" :min="0"
                :max="maxSortOrder ?? 9999" :disabled="isDetailView" placeholder="请输入排序" @input="onSortInput" />
              <button class="sort-btn"
                :disabled="isDetailView || (maxSortOrder !== null && state.ruleForm.sortOrder >= maxSortOrder)"
                @click="onSortChange(1)">+</button>
            </div>
          </a-form-item>
          <a-form-item label="上传模板" name="fileIds" class="upload-form-item">
            <a-upload v-model:file-list="fileList" :action="uploadUrl" :headers="uploadHeaders"
              :disabled="state.viewType === 'detail' || fileList.length >= 1" :before-upload="beforeUpload"
              accept=".pdf,.doc,.docx,.xls,.xlsx,.ppt,.pptx,.txt,.rtf,.zip,.rar" list-type="picture-card"
              @preview="handlePreview" @change="handleChange">
              <template #itemRender="{ originNode, file, actions: { preview, remove } }">
                <template v-if="file.status === 'uploading'">
                  <VNodeRender :vnode="originNode" />
                </template>
                <div v-else class="ant-upload-list-item-container">
                  <div class="ant-upload-list-item ant-upload-list-item-done"
                    :class="{ 'ant-upload-list-item-image': isImageFile(file.name) }">
                    <div class="ant-upload-list-item-thumbnail">
                      <template v-if="isImageFile(file.name)">
                        <img :src="file.url || file.thumbUrl" :alt="file.name" />
                      </template>
                      <span v-else class="ant-upload-list-item-thumbnail-file">
                        <FileOutlined style="font-size: 28px" />
                        <span class="upload-item-name">{{ file.name }}</span>
                      </span>
                    </div>
                    <span class="ant-upload-list-item-actions">
                      <a v-if="isImageFile(file.name)" class="ant-upload-list-item-action" @click.stop="preview()"
                        title="查看">
                        <EyeOutlined />
                      </a>
                      <a class="ant-upload-list-item-action" :href="file.url || file.thumbUrl" :download="file.name"
                        title="下载">
                        <DownloadOutlined />
                      </a>
                      <a v-if="state.viewType !== 'detail'" class="ant-upload-list-item-action" @click.stop="remove()"
                        title="删除">
                        <DeleteOutlined />
                      </a>
                    </span>
                  </div>
                </div>
              </template>
              <div v-if="fileList.length < 1 && state.viewType !== 'detail'">
                <plus-outlined />
                <div style="margin-top: 8px">上传文件</div>
              </div>
            </a-upload>
            <span class="upload-tip" v-if="state.viewType !== 'detail'">仅支持上传文件，不支持图片/视频，单个不超过20MB</span>
            <a-modal :open="previewVisible" :footer="null" @cancel="previewVisible = false">
              <img style="width: 100%" :src="previewImage" />
            </a-modal>
          </a-form-item>
        </a-form>
      </div>
    </a-spin>
    <template #footer>
      <a-button @click="closeDialog">取 消</a-button>
      <a-button class="ml10" type="primary" :loading="state.loading.submit" @click="onSubmit">
        保存
      </a-button>
    </template>
  </ant-Modal>
</template>

<script setup lang="ts" name="dialogMaterial">
import { reactive, ref, nextTick, computed, watch } from 'vue'
import { message, Upload } from 'ant-design-vue'
import { PlusOutlined, FileOutlined, EyeOutlined, DownloadOutlined, DeleteOutlined } from '@ant-design/icons-vue'
import { cloneDeep } from 'lodash-es'
import { useMaterial } from '@/store/material/material'
import { ACCESS_TOKEN } from '@/store/mutation-types'
import storage from '@/utils/Storage'

const materialStore = useMaterial()

// 临时隐藏排序字段
const showSortField = false

const isDetailView = computed(() => state.viewType === 'detail')
const hasCancelOrCloseButton = computed(() => state.viewType !== 'detail' || state.dialog.submitTxt === '关闭')

const emit = defineEmits(['createUpdate'])

const props = defineProps<{
  storeTypeList: any[]
  categoryList: any[]
}>()

const formRef = ref()

const INIT_RULE_FORM = {
  id: undefined as number | undefined,
  materialName: '',
  storeTypeCode: undefined as string | undefined,
  categoryCode: undefined as string | undefined,
  sortOrder: 0,
  fileIds: [] as string[]
}

const state = reactive({
  dialog: {
    visible: false,
    title: '',
    submitTxt: '',
    width: '969px'
  },
  loading: {
    dialogUpload: false,
    submit: false
  },
  ruleForm: cloneDeep(INIT_RULE_FORM),
  rules: {
    materialName: [{ required: true, message: '请输入模板名称', trigger: 'blur' }],
    storeTypeCode: [{ required: true, message: '请选择店铺类型', trigger: 'change' }],
    categoryCode: [{ required: true, message: '请选择分类', trigger: 'change' }],
    fileIds: [{ required: true, message: '请上传模板', trigger: 'change', type: 'array', min: 1 }]
  },
  viewType: ''
})

const fileList = ref<any[]>([])
const maxSortOrder = ref<number | null>(null)
const isInitializing = ref(false)
const previewVisible = ref(false)
const previewImage = ref('')

const VNodeRender = (props: { vnode: any }) => props.vnode

const uploadUrl = computed(() => {
  const base = (import.meta.env.VITE_PROXY || '').replace(/\/+$/, '')
  const path = base ? `${base}/console/file/uploadFile` : '/console/file/uploadFile'
  return `${path}?saveFlag=true`
})

const uploadHeaders = computed(() => {
  return {
    Authorization: storage.get(ACCESS_TOKEN) || ''
  }
})

const allowUploadMimeTypes = [
  'application/pdf',
  'application/msword',
  'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
  'application/vnd.ms-excel',
  'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
  'application/vnd.ms-powerpoint',
  'application/vnd.openxmlformats-officedocument.presentationml.presentation',
  'text/plain',
  'application/rtf',
  'text/rtf',
  'application/x-rtf',
  'application/zip',
  'application/x-zip-compressed',
  'application/x-rar-compressed'
]
const allowUploadExts = ['pdf', 'doc', 'docx', 'xls', 'xlsx', 'ppt', 'pptx', 'txt', 'rtf', 'zip', 'rar']

const openDialog = (type: string, row?: any) => {
  state.viewType = type

  if (type === 'edit' && row) {
    state.dialog.title = '修改模板'
    state.dialog.submitTxt = '修改'
  } else if (type === 'detail' && row) {
    state.dialog.title = '资料详情'
    state.dialog.submitTxt = '关闭'
  } else {
    state.dialog.title = '新增模板'
    state.dialog.submitTxt = '确认'
  }

  state.dialog.visible = true

  nextTick(async () => {
    if ((type === 'edit' || type === 'detail') && row) {
      isInitializing.value = type === 'edit'
      state.ruleForm = {
        id: row.id,
        materialName: row.materialName || '',
        storeTypeCode: row.storeTypeCode,
        categoryCode: row.categoryCode || '',
        sortOrder: row.sortOrder || 0,
        fileIds: (row.fileList || []).map((item: any) => String(item.fileId || '')).filter(Boolean)
      }

      fileList.value = (row.fileList || []).map((item: any, index: number) => ({
        uid: `-${index}`,
        name: item.fileName || '',
        status: 'done',
        url: item.url,
        thumbUrl: item.url,
        fileId: String(item.fileId || '')
      }))

      // 编辑时根据 categoryCode 调接口，判断是否需要调整排序值
      if (showSortField && type === 'edit' && row.categoryCode) {
        try {
          const data: any = await materialStore.getNextSortOrder({ categoryCode: row.categoryCode })
          const num = Number(data)
          if (!isNaN(num)) {
            maxSortOrder.value = num + 1
            if (state.ruleForm.sortOrder > num) {
              state.ruleForm.sortOrder = num + 1
            }
          }
        } catch {
          maxSortOrder.value = null
        }
      }
      isInitializing.value = false
    } else {
      state.ruleForm = cloneDeep(INIT_RULE_FORM)
      fileList.value = []
    }
    formRef.value?.clearValidate()
  })
}

const closeDialog = () => {
  state.dialog.visible = false
  state.loading.submit = false
  state.ruleForm = cloneDeep(INIT_RULE_FORM)
  maxSortOrder.value = null
  isInitializing.value = false
  fileList.value = []
}

const beforeUpload = (file: File) => {
  if (fileList.value.length >= 1) {
    message.error('最多上传1个文件')
    return Upload.LIST_IGNORE
  }
  const fileExt = file.name.split('.').pop()?.toLowerCase() || ''
  const isAllowType = allowUploadMimeTypes.includes(file.type) || allowUploadExts.includes(fileExt)
  if (!isAllowType) {
    message.error('请上传文件类型（不支持图片、视频）')
    return Upload.LIST_IGNORE
  }
  if (file.size / 1024 / 1024 > 20) {
    message.error('文件不能超过20MB')
    return Upload.LIST_IGNORE
  }
  return true
}

const isImageFile = (name: string) => {
  const ext = (name || '').split('.').pop()?.toLowerCase() || ''
  return ['jpg', 'jpeg', 'png', 'gif', 'bmp', 'webp', 'svg', 'ico'].includes(ext)
}

const handlePreview = (file: any) => {
  const url = file.url || file.response?.data?.url || file.thumbUrl
  if (isImageFile(file.name || '')) {
    previewImage.value = url
    previewVisible.value = true
  } else {
    window.open(url)
  }
}


const updateFileIds = () => {
  state.ruleForm.fileIds = fileList.value
    .filter((f: any) => f.status === 'done')
    .map((f: any) => {
      // 已上传文件：优先取后台返回的 id/fileId
      if (f.response?.data) {
        const data = f.response.data
        if (typeof data === 'string') return ''
        return String(data.id || data.fileId || '')
      }
      // 回显文件：取 fileId
      return String(f.fileId || '')
    })
    .filter(Boolean)
}

const handleChange = (info: any) => {
  fileList.value = info.fileList
  updateFileIds()
  if (info.file.status === 'done') {
    const res = info.file.response
    if (res && res.code === 200 && res.data) {
      const data = res.data
      if (typeof data === 'object') {
        info.file.fileId = String(data.id || data.fileId || '')
        info.file.url = data.url || info.file.url
        info.file.thumbUrl = data.url || info.file.thumbUrl
      }
      message.success(`${info.file.name} 上传成功`)
    } else {
      message.error(res?.msg || `${info.file.name} 上传失败`)
      fileList.value = fileList.value.filter((f: any) => f.uid !== info.file.uid)
      updateFileIds()
    }
  } else if (info.file.status === 'error') {
    const res = info.file.response
    message.error(res?.msg || `${info.file.name} 上传失败`)
    fileList.value = fileList.value.filter((f: any) => f.uid !== info.file.uid)
    updateFileIds()
  }
}

const onSubmit = () => {
  if (state.viewType === 'detail') {
    closeDialog()
    return
  }
  formRef.value
    .validate()
    .then(async () => {
      state.loading.submit = true
      const fileIds = fileList.value
        .filter((f) => f.status === 'done')
        .map((f) => {
          if (f.response?.data) {
            const data = f.response.data
            if (typeof data === 'string') return ''
            return String(data.id || data.fileId || '')
          }
          return String(f.fileId || '')
        })
        .filter(Boolean)

      const param = {
        ...cloneDeep(state.ruleForm),
        fileIds
      }
      if (!showSortField) {
        delete param.sortOrder
      }

      try {
        if (state.viewType === 'add') {
          await materialStore.createMaterial(param)
        } else {
          await materialStore.updateMaterial(param)
        }
        state.loading.submit = false
        emit('createUpdate')
      } catch {
        state.loading.submit = false
      }
    })
    .catch(() => {
      state.loading.submit = false
    })
}

const onSortChange = (delta: number) => {
  let val = (state.ruleForm.sortOrder || 0) + delta
  if (val < 0) val = 0
  if (maxSortOrder.value !== null && val > maxSortOrder.value) val = maxSortOrder.value
  state.ruleForm.sortOrder = val
}

const onSortInput = (e: Event) => {
  const val = parseInt((e.target as HTMLInputElement).value, 10)
  if (isNaN(val)) {
    state.ruleForm.sortOrder = undefined as any
    return
  }
  if (val < 0) {
    state.ruleForm.sortOrder = 0
    return
  }
  if (maxSortOrder.value !== null && val > maxSortOrder.value) {
    state.ruleForm.sortOrder = maxSortOrder.value
    return
  }
  state.ruleForm.sortOrder = val
}

watch(
  () => state.ruleForm.categoryCode,
  async (code) => {
    if (isInitializing.value) return
    if (!showSortField || state.viewType === 'detail' || !code) {
      maxSortOrder.value = null
      return
    }
    try {
      const data: any = await materialStore.getNextSortOrder({ categoryCode: code })
      const num = Number(data)
      if (!isNaN(num)) {
        maxSortOrder.value = num + 1
        if (state.viewType === 'add') {
          state.ruleForm.sortOrder = maxSortOrder.value
        } else if (state.ruleForm.sortOrder > maxSortOrder.value) {
          state.ruleForm.sortOrder = maxSortOrder.value
        }
      }
    } catch {
      maxSortOrder.value = null
    }
  }
)

defineExpose({
  openDialog,
  closeDialog
})
</script>

<style scoped lang="less">
.form-content {
  padding: 40px 35px 32px 35px;
}

// ===== 表单 =====
:deep(.ant-form-item) {
  margin-bottom: 0px;
  padding-bottom: 24px;
}

:deep(.ant-form-item-label) {
  margin-left: 0px;
  margin-right: 5px;
  width: 80px;
  text-align: right;
  justify-content: flex-end;
  display: flex;
  align-items: center;
  height: 40px;
}

:deep(.ant-form-item-label > label) {
  font-size: 14px;
  line-height: 1;
  font-weight: 400;
}

:deep(.ant-input-affix-wrapper) {
  height: 40px;
  padding: 0 11px;
  border-radius: 4px;
  display: flex;
  align-items: center;
}

:deep(.ant-input-disabled) {
  height: 40px;
  border-color: #C5C5D3;
  border-radius: 4px;
}

:deep(.ant-select-selector) {
  height: 40px !important;
  display: flex;
  align-items: center;
  border-radius: 4px;
}

// 只覆盖默认态，hover/focus 保留 Ant Design 蓝色
:deep(.ant-input-affix-wrapper:not(:hover):not(.ant-input-affix-wrapper-focused)) {
  border-color: #C5C5D3;
}

// 只覆盖默认态，hover/focus 保留 Ant Design 蓝色
:deep(.ant-select:not(.ant-select-disabled):not(.ant-select-focused) .ant-select-selector:not(:hover)) {
  border-color: #C5C5D3;
}

// 只覆盖默认态，hover/focus 保留 Ant Design 蓝色
:deep(textarea.ant-input:not(:hover):not(:focus)) {
  border-color: #C5C5D3;
}

:deep(.ant-upload-list-item) {
  width: 100%;
  height: 100%;
}

:deep(.ant-upload-list-item.ant-upload-list-item-done) {
  position: relative;
  padding: 0 !important;

  &::before {
    position: absolute;
    inset: 0;
    width: 100% !important;
    height: 100% !important;
    margin: 0 !important;
    padding: 0 !important;
  }
}

.upload-form-item :deep(.ant-upload-list-item) {
  border: 1px dashed #d9d9d9;
}


.sort-input-number {
  display: flex;
  border: 1px solid #C5C5D3;
  border-radius: 4px;
  width: fit-content;

  .sort-btn {
    width: 40px;
    height: 40px;
    background: #fff;
    border: none;
    cursor: pointer;

    &:disabled {
      background: #f5f5f5;
      color: #bbb;
      cursor: not-allowed;
    }
  }

  .sort-input {
    width: 80px;
    height: 40px;
    border: none;
    border-left: 1px solid #C5C5D3;
    border-right: 1px solid #C5C5D3;
    text-align: center;
    outline: none;

    &::-webkit-inner-spin-button,
    &::-webkit-outer-spin-button {
      -webkit-appearance: none;
      margin: 0;
    }

    &:disabled {
      background: #f5f5f5;
      color: #bbb;
    }
  }
}


.upload-tip {
  display: block;
  color: #999;
  margin-top: 8px;
  font-size: 12px;
}

.upload-form-item :deep(.ant-upload-list-item-thumbnail-file) {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  height: 100%;
  color: rgba(0, 0, 0, 0.45);
  background: #fafafa;
}

.upload-item-name {
  display: block;
  font-size: 11px;
  word-break: break-all;
  padding: 4px 8px;
  line-height: 1.3;
  max-width: 88px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
</style>
